/* tslint:disable:max-line-length */
import fetch from '../api/fetch'

/**
 * 	Action to fetch search
 *
 * 	@method GET
 */

export function fetchSearch(search: string, filters: any) {
    let params = `?searchCriteria=${search}&quotesSortedType=${filters.quotesSortedType}&quotesSortedBy=${filters.quotesSortedBy}&pageQuotes=${filters.pageQuotes}&perPageQuotes=${filters.perPageQuotes}&policiesSortedType=${filters.policiesSortedType}&policiesSortedBy=${filters.policiesSortedBy}&pagePolicies=${filters.pagePolicies}&perPagePolicies=${filters.perPagePolicies}&renewalsSortedType=${filters.renewalsSortedType}&renewalsSortedBy=${filters.renewalsSortedBy}&pageRenewals=${filters.pageRenewals}&perPageRenewals=${filters.perPageRenewals}`
    return {
        type: 'FETCH_SEARCH',
        payload: fetch(`/search${params}`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/search.ts